<template>
  <div>
    <section class="p-box">
      <header class="p-box__header pageHeader">
        <div class="c-button">
          <router-link
            :to="{ name: 'CompaniesVisitorStores', params: { company_uuid: companyUuid } }"
            class="backButton c-button__item c-button__item--outline"
            v-text="$t('labels.backToList')"
          />
        </div>
      </header>
      <div>
        <Loading v-show="loading" />
        <template v-if="dataLoaded">
          <ValidationObserver ref="form">
            <form @submit.prevent>
              <div class="p-box__body">
                <div v-show="store.attributes.visible" class="c-alert">
                  <div class="c-alert__icon">
                    <img :src="iconExclamationPath" alt="">
                  </div>
                  <div class="c-alert__content">
                    <div class="c-alert__detail">
                      <p>{{ $t('pages.CompaniesVisitorStoreEdit.gatingWarning1') }}</p>
                      <p>{{ $t('pages.CompaniesVisitorStoreEdit.gatingWarning2') }}</p>
                    </div>
                  </div>
                </div>
                <div class="c-info">
                  <div class="c-info__icon">
                    <Icon name="iconQuestion" />
                  </div>
                  <div class="c-info__content">
                    <p>{{ $t('pages.CompaniesVisitorStoreEdit.description') }}</p>
                  </div>
                </div>

                <div v-show="!store.attributes.visible" class="c-alert">
                  <div class="c-alert__icon">
                    <img :src="iconExclamationPath" alt="">
                  </div>
                  <div class="c-alert__content">
                    <h3 class="c-alert__title">{{ $t('pages.CompaniesVisitorStoreEdit.warning1') }}</h3>
                    <div class="c-alert__detail">
                      <p>{{ $t('pages.CompaniesVisitorStoreEdit.warning2') }}</p>
                    </div>
                  </div>
                </div>
                <div class="c-grid">
                  <div class="c-grid__items">
                    <div class="c-grid__item c-grid__item__s__12 c-grid__item__m__7 c-grid__item__l__7">
                      <section class="p-box">
                        <header class="p-box__header">
                          <h3 class="p-box__title">{{ $t('pages.CompaniesVisitorStoreEdit.coverImageSetting.head') }}</h3>
                        </header>
                        <div class="p-box__body">
                          <div class="p-formGrid">
                            <div class="p-formGrid__items">
                              <fieldset v-if="inboundOption" class="p-formGrid__item p-formGrid__item__s__12 p-formGrid__item__m__12 p-formGrid__item__l__12">
                                <KkToggleSwitch
                                  id="enableMultiLang"
                                  :label="$t('pages.CompaniesVisitorStoreEdit.coverImageSetting.enableMultiLang')"
                                  :model-value="enableMultiLang"
                                  @update:model-value="value => clickEnableMultiToggle(value)"
                                />
                              </fieldset>
                              <fieldset class="p-formGrid__item p-formGrid__item__s__12 p-formGrid__item__m__12 p-formGrid__item__l__12">
                                <label class="c-fileLoader">
                                  <div class="c-fileLoader__icon"><img :src="iconPlusPath" alt=""></div>
                                  <div class="c-fileLoader__name">{{ $t('labels.selectImage') }}</div>
                                  <input
                                    type="file"
                                    accept="image/jpeg,image/gif,image/png"
                                    @change="uploadStoreCoverImage"
                                  >
                                </label>
                                <ValidationError :error="imageError" />
                                <div class="c-note">
                                  <div class="c-note__content">
                                    <p>{{ $t('labels.recommendedImageSize', { width: 750, height: 400 }) }}</p>
                                  </div>
                                </div>
                              </fieldset>
                              <!-- カバータイトル -->
                              <fieldset class="p-formGrid__item p-formGrid__item__s__12 p-formGrid__item__m__12 p-formGrid__item__l__12">
                                <!-- 多言語設定されていない場合のカバータイトル -->
                                <section v-if="!enableMultiLang || !inboundOption">
                                  <label class="c-formLabel">
                                    <p>{{ formatLabelText({ label: 'pages.CompaniesVisitorStoreEdit.coverImageSetting.title', max: 140, currentLength: store.attributes.store_cover.title.length, required: false }) }}</p>
                                  </label>
                                  <ValidationProvider v-slot="{ errors, value, handleChange }"
                                                      key="title"
                                                      v-model="store.attributes.store_cover.title"
                                                      :name="$t('pages.CompaniesVisitorStoreEdit.coverImageSetting.title')"
                                                      rules="max:140"
                                  >
                                    <input :value="value" class="c-textField" :placeholder="$t('labels.placeholder.basic')" @input="handleChange">
                                    <ValidationError :error="errors[0]" />
                                  </ValidationProvider>
                                </section>
                                <!-- 多言語設定されている場合のカバータイトル -->
                                <section v-else class="p-box">
                                  <div class="p-box__body">
                                    <label class="c-formLabel">
                                      <p>{{ formatLabelText({ label: 'pages.CompaniesVisitorStoreEdit.coverImageSetting.multiLang.title.japanese', max: 140, currentLength: store.attributes.store_cover.title.length, required: false }) }}</p>
                                    </label>
                                    <ValidationProvider v-slot="{ errors, value, handleChange }"
                                                        key="title"
                                                        v-model="store.attributes.store_cover.title"
                                                        :name="$t('pages.CompaniesVisitorStoreEdit.coverImageSetting.multiLang.title.japanese')"
                                                        rules="max:140"
                                    >
                                      <input :value="value" class="c-textField" :placeholder="$t('labels.placeholder.basic')" @input="handleChange">
                                      <ValidationError :error="errors[0]" />
                                    </ValidationProvider>
                                    <div class="multiLang">
                                      <p class="multiLang__status">
                                        <StatusBadge :status="1" />
                                        {{ $t('pages.CompaniesVisitorStoreEdit.coverImageSetting.multiLang.setMultiLang') }}
                                      </p>
                                      <label class="c-formLabel">
                                        <p>{{ formatLabelText({ label: 'pages.CompaniesVisitorStoreEdit.coverImageSetting.multiLang.label.english', max: 140, currentLength: store.attributes.store_multi_language_cover.en_title.length, required: false }) }}</p>
                                      </label>
                                      <ValidationProvider v-slot="{ errors, value, handleChange }"
                                                          key="en_title"
                                                          v-model="store.attributes.store_multi_language_cover.en_title"
                                                          :name="$t('pages.CompaniesVisitorStoreEdit.coverImageSetting.multiLang.title.english')"
                                                          rules="max:140"
                                      >
                                        <input :value="value" class="c-textField" :placeholder="$t('labels.placeholder.basic')" @input="handleChange">
                                        <ValidationError :error="errors[0]" />
                                      </ValidationProvider>

                                      <label class="c-formLabel">
                                        <p>{{ formatLabelText({ label: 'pages.CompaniesVisitorStoreEdit.coverImageSetting.multiLang.label.traditionalChinese', max: 140, currentLength: store.attributes.store_multi_language_cover.zh_tw_title.length, required: false }) }}</p>
                                      </label>
                                      <ValidationProvider v-slot="{ errors, value, handleChange }"
                                                          key="zh_tw_title"
                                                          v-model="store.attributes.store_multi_language_cover.zh_tw_title"
                                                          :name="$t('pages.CompaniesVisitorStoreEdit.coverImageSetting.multiLang.title.traditionalChinese')"
                                                          rules="max:140"
                                      >
                                        <input :value="value" class="c-textField" :placeholder="$t('labels.placeholder.basic')" @input="handleChange">
                                        <ValidationError :error="errors[0]" />
                                      </ValidationProvider>
                                      <label class="c-formLabel">
                                        <p>{{ formatLabelText({ label: 'pages.CompaniesVisitorStoreEdit.coverImageSetting.multiLang.label.korean', max: 140, currentLength: store.attributes.store_multi_language_cover.ko_title.length, required: false }) }}</p>
                                      </label>
                                      <ValidationProvider v-slot="{ errors, value, handleChange }"
                                                          key="ko_title"
                                                          v-model="store.attributes.store_multi_language_cover.ko_title"
                                                          :name="$t('pages.CompaniesVisitorStoreEdit.coverImageSetting.multiLang.title.korean')"
                                                          rules="max:140"
                                      >
                                        <input :value="value" class="c-textField" :placeholder="$t('labels.placeholder.basic')" @input="handleChange">
                                        <ValidationError :error="errors[0]" />
                                      </ValidationProvider>
                                      <button class="multiLang__restore" @click="restore('title')">
                                        <KkIcon name="return" color="#3A3B3F" class="multiLang__restore__icon" />
                                        {{ $t('pages.CompaniesVisitorStoreEdit.coverImageSetting.multiLang.restoreWording') }}
                                      </button>
                                    </div>
                                  </div>
                                </section>
                              </fieldset>
                              <!-- カバー文言 -->
                              <fieldset class="p-formGrid__item p-formGrid__item__s__12 p-formGrid__item__m__12 p-formGrid__item__l__12">
                                <!-- 多言語設定されていない場合のカバー文言 -->
                                <section v-if="!enableMultiLang || !inboundOption">
                                  <label class="c-formLabel">
                                    <p>{{ formatLabelText({ label: 'pages.CompaniesVisitorStoreEdit.coverImageSetting.comment', max: 400, currentLength: store.attributes.store_cover.comment.length, required: false }) }}</p>
                                  </label>
                                  <ValidationProvider v-slot="{ errors, value, handleChange }"
                                                      key="comment"
                                                      v-model="store.attributes.store_cover.comment"
                                                      :name="$t('pages.CompaniesVisitorStoreEdit.coverImageSetting.comment')"
                                                      rules="max:400"
                                  >
                                    <textarea
                                      :value="value"
                                      class="c-textArea"
                                      rows="5"
                                      @input="handleChange"
                                    />
                                    <ValidationError :error="errors[0]" />
                                  </ValidationProvider>
                                </section>
                                <!-- 多言語設定されている場合のカバー文言 -->
                                <section v-else class="p-box">
                                  <div class="p-box__body">
                                    <label class="c-formLabel">
                                      <p>{{ formatLabelText({ label: 'pages.CompaniesVisitorStoreEdit.coverImageSetting.multiLang.comment.japanese', max: 400, currentLength: store.attributes.store_cover.comment.length, required: false }) }}</p>
                                    </label>
                                    <ValidationProvider v-slot="{ errors, value, handleChange }"
                                                        key="comment"
                                                        v-model="store.attributes.store_cover.comment"
                                                        :name="$t('pages.CompaniesVisitorStoreEdit.coverImageSetting.multiLang.comment.japanese')"
                                                        rules="max:400"
                                    >
                                      <textarea
                                        :value="value"
                                        class="c-textArea"
                                        rows="5"
                                        @input="handleChange"
                                      />
                                      <ValidationError :error="errors[0]" />
                                    </ValidationProvider>
                                    <div class="multiLang">
                                      <p class="multiLang__status">
                                        <StatusBadge :status="1" />
                                        {{ $t('pages.CompaniesVisitorStoreEdit.coverImageSetting.multiLang.setMultiLang') }}
                                      </p>
                                      <label class="c-formLabel">
                                        <p>{{ formatLabelText({ label: 'pages.CompaniesVisitorStoreEdit.coverImageSetting.multiLang.label.english', max: 400, currentLength: store.attributes.store_multi_language_cover.en_comment.length, required: false }) }}</p>
                                      </label>
                                      <ValidationProvider v-slot="{ errors, value, handleChange }"
                                                          key="en_comment"
                                                          v-model="store.attributes.store_multi_language_cover.en_comment"
                                                          :name="$t('pages.CompaniesVisitorStoreEdit.coverImageSetting.multiLang.comment.english')"
                                                          rules="max:400"
                                      >
                                        <textarea
                                          :value="value"
                                          class="c-textArea"
                                          rows="5"
                                          @input="handleChange"
                                        />
                                        <ValidationError :error="errors[0]" />
                                      </ValidationProvider>
                                      <label class="c-formLabel">
                                        <p>{{ formatLabelText({ label: 'pages.CompaniesVisitorStoreEdit.coverImageSetting.multiLang.label.traditionalChinese', max: 400, currentLength: store.attributes.store_multi_language_cover.zh_tw_comment.length, required: false }) }}</p>
                                      </label>
                                      <ValidationProvider v-slot="{ errors, value, handleChange }"
                                                          key="zh_tw_comment"
                                                          v-model="store.attributes.store_multi_language_cover.zh_tw_comment"
                                                          :name="$t('pages.CompaniesVisitorStoreEdit.coverImageSetting.multiLang.comment.traditionalChinese')"
                                                          rules="max:400"
                                      >
                                        <textarea
                                          :value="value"
                                          class="c-textArea"
                                          rows="5"
                                          @input="handleChange"
                                        />
                                        <ValidationError :error="errors[0]" />
                                      </ValidationProvider>
                                      <label class="c-formLabel">
                                        <p>{{ formatLabelText({ label: 'pages.CompaniesVisitorStoreEdit.coverImageSetting.multiLang.label.korean', max: 400, currentLength: store.attributes.store_multi_language_cover.ko_comment.length, required: false }) }}</p>
                                      </label>
                                      <ValidationProvider v-slot="{ errors, value, handleChange }"
                                                          key="ko_comment"
                                                          v-model="store.attributes.store_multi_language_cover.ko_comment"
                                                          :name="$t('pages.CompaniesVisitorStoreEdit.coverImageSetting.multiLang.comment.korean')"
                                                          rules="max:400"
                                      >
                                        <textarea
                                          :value="value"
                                          class="c-textArea"
                                          rows="5"
                                          @input="handleChange"
                                        />
                                        <ValidationError :error="errors[0]" />
                                      </ValidationProvider>
                                      <button class="multiLang__restore" @click="restore('comment')">
                                        <KkIcon name="return" color="#3A3B3F" class="multiLang__restore__icon" />
                                        {{ $t('pages.CompaniesVisitorStoreEdit.coverImageSetting.multiLang.restoreWording') }}
                                      </button>
                                    </div>
                                  </div>
                                </section>
                              </fieldset>
                              <!-- 口コミ投稿ボタンのラベル -->
                              <fieldset
                                v-if="store.attributes.review_site_display_location !== 'survey_complete'"
                                class="p-formGrid__item p-formGrid__item__s__12 p-formGrid__item__m__12 p-formGrid__item__l__12"
                              >
                                <!-- 多言語設定されていない場合の口コミ投稿ボタンのラベル -->
                                <section v-if="!enableMultiLang || !inboundOption">
                                  <label class="c-formLabel">
                                    <p>{{ formatLabelText({ label: 'pages.CompaniesVisitorStoreEdit.coverImageSetting.postLabel', max: 10, currentLength: store.attributes.store_cover.post_label.length }) }}</p>
                                  </label>
                                  <ValidationProvider v-slot="{ errors, value, handleChange }"
                                                      key="post_label"
                                                      v-model="store.attributes.store_cover.post_label"
                                                      :name="$t('pages.CompaniesVisitorStoreEdit.coverImageSetting.postLabel')"
                                                      rules="required|max:10"
                                  >
                                    <input :value="value" class="c-textField" :placeholder="$t('labels.placeholder.basic')" @input="handleChange">
                                    <ValidationError :error="errors[0]" />
                                  </ValidationProvider>
                                  <div class="c-note">
                                    <div class="c-note__content">
                                      <p>{{ $t('pages.CompaniesVisitorStoreEdit.coverImageSetting.postNote') }}</p>
                                    </div>
                                  </div>
                                </section>
                                <!-- 多言語設定されている場合の口コミ投稿ボタンのラベル -->
                                <section v-else class="p-box">
                                  <div class="p-box__body">
                                    <label class="c-formLabel">
                                      <p>{{ formatLabelText({ label: 'pages.CompaniesVisitorStoreEdit.coverImageSetting.multiLang.postLabel.japanese', max: 10, currentLength: store.attributes.store_cover.post_label.length }) }}</p>
                                    </label>
                                    <ValidationProvider v-slot="{ errors, value, handleChange }"
                                                        key="post_label"
                                                        v-model="store.attributes.store_cover.post_label"
                                                        :name="$t('pages.CompaniesVisitorStoreEdit.coverImageSetting.multiLang.postLabel.japanese')"
                                                        rules="required|max:10"
                                    >
                                      <input :value="value" class="c-textField" :placeholder="$t('labels.placeholder.basic')" @input="handleChange">
                                      <ValidationError :error="errors[0]" />
                                    </ValidationProvider>
                                    <div class="c-note">
                                      <div class="c-note__content">
                                        <p>{{ $t('pages.CompaniesVisitorStoreEdit.coverImageSetting.postNote') }}</p>
                                      </div>
                                    </div>
                                    <div class="multiLang">
                                      <p class="multiLang__status">
                                        <StatusBadge :status="1" />
                                        {{ $t('pages.CompaniesVisitorStoreEdit.coverImageSetting.multiLang.setMultiLang') }}
                                      </p>
                                      <label class="c-formLabel">
                                        <p>{{ formatLabelText({ label: 'pages.CompaniesVisitorStoreEdit.coverImageSetting.multiLang.label.english', max: 25, currentLength: store.attributes.store_multi_language_cover.en_post_label.length }) }}</p>
                                      </label>
                                      <ValidationProvider v-slot="{ errors, value, handleChange }"
                                                          key="en_post_label"
                                                          v-model="store.attributes.store_multi_language_cover.en_post_label"
                                                          :name="$t('pages.CompaniesVisitorStoreEdit.coverImageSetting.multiLang.postLabel.english')"
                                                          rules="required|max:25"
                                      >
                                        <input :value="value" class="c-textField" :placeholder="$t('labels.placeholder.basic')" @input="handleChange">
                                        <ValidationError :error="errors[0]" />
                                      </ValidationProvider>

                                      <label class="c-formLabel">
                                        <p>{{ formatLabelText({ label: 'pages.CompaniesVisitorStoreEdit.coverImageSetting.multiLang.label.traditionalChinese', max: 10, currentLength: store.attributes.store_multi_language_cover.zh_tw_post_label.length }) }}</p>
                                      </label>
                                      <ValidationProvider v-slot="{ errors, value, handleChange }"
                                                          key="zh_tw_post_label"
                                                          v-model="store.attributes.store_multi_language_cover.zh_tw_post_label"
                                                          :name="$t('pages.CompaniesVisitorStoreEdit.coverImageSetting.multiLang.postLabel.traditionalChinese')"
                                                          rules="required|max:10"
                                      >
                                        <input :value="value" class="c-textField" :placeholder="$t('labels.placeholder.basic')" @input="handleChange">
                                        <ValidationError :error="errors[0]" />
                                      </ValidationProvider>
                                      <label class="c-formLabel">
                                        <p>{{ formatLabelText({ label: 'pages.CompaniesVisitorStoreEdit.coverImageSetting.multiLang.label.korean', max: 10, currentLength: store.attributes.store_multi_language_cover.ko_post_label.length }) }}</p>
                                      </label>
                                      <ValidationProvider v-slot="{ errors, value, handleChange }"
                                                          key="ko_post_label"
                                                          v-model="store.attributes.store_multi_language_cover.ko_post_label"
                                                          :name="$t('pages.CompaniesVisitorStoreEdit.coverImageSetting.multiLang.postLabel.korean')"
                                                          rules="required|max:10"
                                      >
                                        <input :value="value" class="c-textField" :placeholder="$t('labels.placeholder.basic')" @input="handleChange">
                                        <ValidationError :error="errors[0]" />
                                      </ValidationProvider>
                                      <button class="multiLang__restore" @click="restore('postLabel')">
                                        <KkIcon name="return" color="#3A3B3F" class="multiLang__restore__icon" />
                                        {{ $t('pages.CompaniesVisitorStoreEdit.coverImageSetting.multiLang.restoreWording') }}
                                      </button>
                                    </div>
                                  </div>
                                </section>
                              </fieldset>
                              <!-- 日本語アンケート機能ボタンのラベル -->
                              <fieldset v-if="providedFeaturesSurvey" class="p-formGrid__item p-formGrid__item__s__12 p-formGrid__item__m__12 p-formGrid__item__l__12">
                                <!-- 多言語設定されていない場合の日本語アンケート機能ボタンのラベル -->
                                <section v-if="!enableMultiLang || !inboundOption">
                                  <label class="c-formLabel">
                                    <p>{{ formatLabelText({ label: 'pages.CompaniesVisitorStoreEdit.coverImageSetting.surveyLabel', max: 10, currentLength: store.attributes.store_cover.survey_label.length }) }}</p>
                                  </label>
                                  <ValidationProvider v-slot="{ errors, value, handleChange }"
                                                      key="survey_label"
                                                      v-model="store.attributes.store_cover.survey_label"
                                                      :name="$t('pages.CompaniesVisitorStoreEdit.coverImageSetting.surveyLabel')"
                                                      rules="required|max:10"
                                  >
                                    <input class="c-textField" :value="value" :placeholder="$t('labels.placeholder.basic')" @input="handleChange">
                                    <ValidationError :error="errors[0]" />
                                  </ValidationProvider>
                                  <div class="c-note">
                                    <div class="c-note__content">
                                      <p>
                                        {{ $t('pages.CompaniesVisitorStoreEdit.coverImageSetting.surveyNote') }}
                                        <router-link :to="{ name: 'CompaniesSurveys', params: { company_uuid: companyUuid } }">
                                          {{ $t('pages.CompaniesVisitorStoreEdit.coverImageSetting.surveyNoteUrl') }}
                                        </router-link>
                                      </p>
                                    </div>
                                  </div>
                                </section>
                                <!-- 多言語設定されている日本語アンケート機能ボタンのラベル -->
                                <section v-else class="p-box">
                                  <div class="p-box__body">
                                    <label class="c-formLabel">
                                      <p>{{ formatLabelText({ label: 'pages.CompaniesVisitorStoreEdit.coverImageSetting.multiLang.surveyLabel.japanese', max: 10, currentLength: store.attributes.store_cover.survey_label.length }) }}</p>
                                    </label>
                                    <ValidationProvider v-slot="{ errors, value, handleChange }"
                                                        key="survey_label"
                                                        v-model="store.attributes.store_cover.survey_label"
                                                        :name="$t('pages.CompaniesVisitorStoreEdit.coverImageSetting.multiLang.surveyLabel.japanese')"
                                                        rules="required|max:10"
                                    >
                                      <input :value="value" class="c-textField" :placeholder="$t('labels.placeholder.basic')" @input="handleChange">
                                      <ValidationError :error="errors[0]" />
                                    </ValidationProvider>
                                    <div class="c-note">
                                      <div class="c-note__content">
                                        <p>
                                          {{ $t('pages.CompaniesVisitorStoreEdit.coverImageSetting.surveyNote') }}
                                          <router-link :to="{ name: 'CompaniesSurveys', params: { company_uuid: companyUuid } }">
                                            {{ $t('pages.CompaniesVisitorStoreEdit.coverImageSetting.surveyNoteUrl') }}
                                          </router-link>
                                        </p>
                                      </div>
                                    </div>
                                    <div class="multiLang">
                                      <p class="multiLang__status">
                                        <StatusBadge :status="1" />
                                        {{ $t('pages.CompaniesVisitorStoreEdit.coverImageSetting.multiLang.setMultiLang') }}
                                      </p>
                                      <label class="c-formLabel">
                                        <p>{{ formatLabelText({ label: 'pages.CompaniesVisitorStoreEdit.coverImageSetting.multiLang.label.english', max: 25, currentLength: store.attributes.store_multi_language_cover.en_survey_label.length }) }}</p>
                                      </label>
                                      <ValidationProvider v-slot="{ errors, value, handleChange }"
                                                          key="en_survey_label"
                                                          v-model="store.attributes.store_multi_language_cover.en_survey_label"
                                                          :name="$t('pages.CompaniesVisitorStoreEdit.coverImageSetting.multiLang.surveyLabel.english')"
                                                          rules="required|max:25"
                                      >
                                        <input :value="value" class="c-textField" :placeholder="$t('labels.placeholder.basic')" @input="handleChange">
                                        <ValidationError :error="errors[0]" />
                                      </ValidationProvider>

                                      <label class="c-formLabel">
                                        <p>{{ formatLabelText({ label: 'pages.CompaniesVisitorStoreEdit.coverImageSetting.multiLang.label.traditionalChinese', max: 10, currentLength: store.attributes.store_multi_language_cover.zh_tw_survey_label.length }) }}</p>
                                      </label>
                                      <ValidationProvider v-slot="{ errors, value, handleChange }"
                                                          key="zh_tw_survey_label"
                                                          v-model="store.attributes.store_multi_language_cover.zh_tw_survey_label"
                                                          :name="$t('pages.CompaniesVisitorStoreEdit.coverImageSetting.multiLang.surveyLabel.traditionalChinese')"
                                                          rules="required|max:10"
                                      >
                                        <input :value="value" class="c-textField" :placeholder="$t('labels.placeholder.basic')" @input="handleChange">
                                        <ValidationError :error="errors[0]" />
                                      </ValidationProvider>
                                      <label class="c-formLabel">
                                        <p>{{ formatLabelText({ label: 'pages.CompaniesVisitorStoreEdit.coverImageSetting.multiLang.label.korean', max: 10, currentLength: store.attributes.store_multi_language_cover.ko_survey_label.length }) }}</p>
                                      </label>
                                      <ValidationProvider v-slot="{ errors, value, handleChange }"
                                                          key="ko_survey_label"
                                                          v-model="store.attributes.store_multi_language_cover.ko_survey_label"
                                                          :name="$t('pages.CompaniesVisitorStoreEdit.coverImageSetting.multiLang.surveyLabel.korean')"
                                                          rules="required|max:10"
                                      >
                                        <input :value="value" class="c-textField" :placeholder="$t('labels.placeholder.basic')" @input="handleChange">
                                        <ValidationError :error="errors[0]" />
                                      </ValidationProvider>
                                      <button class="multiLang__restore" @click="restore('surveyLabel')">
                                        <KkIcon name="return" color="#3A3B3F" class="multiLang__restore__icon" />
                                        {{ $t('pages.CompaniesVisitorStoreEdit.coverImageSetting.multiLang.restoreWording') }}
                                      </button>
                                    </div>
                                  </div>
                                </section>
                              </fieldset>
                            </div>
                          </div>
                        </div>
                      </section>
                      <section class="p-box visibleSite">
                        <header class="p-box__header">
                          <h3 class="p-box__title">{{ $t('pages.CompaniesVisitorStoreEdit.reviewPostVisibleSetting.title') }}</h3>
                        </header>
                        <div class="p-box__body">
                          <div class="p-box__info">
                            <div class="c-info">
                              <div class="c-info__icon">
                                <Icon name="iconQuestion" />
                              </div>
                              <div class="c-info__content">
                                <p v-if="store.attributes.review_site_display_location === 'survey_complete'">{{ $t('pages.CompaniesVisitorStoreEdit.reviewPostVisibleSetting.description2') }}</p>
                                <p v-else>{{ $t('pages.CompaniesVisitorStoreEdit.reviewPostVisibleSetting.description1') }}</p>
                              </div>
                            </div>
                            <div class="p-formGrid p-formGrid--border">
                              <div class="p-formGrid__items">
                                <ul class="c-checkbox">
                                  <li
                                    v-for="(store_site, i) in store.attributes.store_sites"
                                    :key="i"
                                    class="c-checkbox__item c-checkbox__item__s__12 c-checkbox__item__m__12 c-checkbox__item__l__12"
                                  >
                                    <input :id="store_site.siteType" v-model="store_site.visible" type="checkbox" class="c-checkbox__input" :disabled="!store_site.visible && !store_site.url">
                                    <label class="c-checkbox__label c-formLabel" :for="store_site.siteType">
                                      <div class="c-icon c-icon--square" :class="!store_site.url && 'is_disabled'">
                                        <KkSiteIcon :name="store_site.siteType" />
                                      </div>
                                      <p>{{ store_site.name }}</p>
                                    </label>
                                    <small v-if="!store_site.url">※ {{ $t('messages.notSet', { value: 'URL' }) }}</small>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </div>
                          <div class="c-note">
                            <div class="c-note__content">
                              <i18n-t keypath="pages.CompaniesVisitorStoreEdit.reviewPostVisibleSetting.note" tag="p">
                                <a target="_blank" :href="`/s/companies/${ companyUuid }/location/stores/${ storeUuid }/connects`">{{ $t('labels.here') }}</a>
                              </i18n-t>
                            </div>
                          </div>
                        </div>
                      </section>
                      <section class="p-box">
                        <header class="p-box__header">
                          <h3 class="p-box__title">{{ $t('pages.CompaniesVisitorStoreEdit.snsVisibleSetting.title') }}</h3>
                        </header>
                        <div class="p-box__body">
                          <div class="p-box__info">
                            <div class="c-info">
                              <div class="c-info__icon">
                                <Icon name="iconQuestion" />
                              </div>
                              <div class="c-info__content">
                                <p>{{ $t('pages.CompaniesVisitorStoreEdit.snsVisibleSetting.description') }}</p>
                              </div>
                            </div>
                          </div>
                          <div class="p-formGrid p-formGrid--border">
                            <div class="p-formGrid__items">
                              <fieldset class="p-formGrid__item p-formGrid__item__s__12 p-formGrid__item__m__12 p-formGrid__item__l__12">
                                <input
                                  id="isDisplayFacebookCheckbox"
                                  v-model="isDisplayFacebook"
                                  type="checkbox"
                                  class="c-checkbox__input"
                                  :disabled="!store.attributes.store_social.facebook_url"
                                >
                                <label
                                  class="c-formLabel"
                                  :class="`${ store.attributes.store_social.facebook_url ? 'c-checkbox__label' : 'noCheckbox' }`"
                                  for="isDisplayFacebookCheckbox"
                                >
                                  <div class="c-icon c-icon--facebook" :class="!store.attributes.store_social.facebook_url && 'is_disabled'">
                                    <Icon name="iconFacebook" />
                                  </div>
                                  <p>Facebook</p>
                                </label>
                              </fieldset>
                              <fieldset class="p-formGrid__item p-formGrid__item__s__12 p-formGrid__item__m__12 p-formGrid__item__l__12">
                                <input
                                  id="isDisplayTwitterCheckbox"
                                  v-model="isDisplayTwitter"
                                  type="checkbox"
                                  class="c-checkbox__input"
                                  :disabled="!store.attributes.store_social.twitter_url"
                                >
                                <label
                                  class="c-formLabel"
                                  :class="`${ store.attributes.store_social.twitter_url ? 'c-checkbox__label' : 'noCheckbox' }`"
                                  for="isDisplayTwitterCheckbox"
                                >
                                  <div class="c-icon c-icon--twitter" :class="!store.attributes.store_social.twitter_url && 'is_disabled'">
                                    <Icon name="iconTwitter" />
                                  </div>
                                  <p>X</p>
                                </label>
                              </fieldset>
                              <fieldset class="p-formGrid__item p-formGrid__item__s__12 p-formGrid__item__m__12 p-formGrid__item__l__12">
                                <input
                                  id="isDisplayInstagramCheckbox"
                                  v-model="isDisplayInstagram"
                                  type="checkbox"
                                  class="c-checkbox__input"
                                  :disabled="!store.attributes.store_social.instagram_url"
                                >
                                <label
                                  class="c-formLabel"
                                  :class="`${ store.attributes.store_social.instagram_url ? 'c-checkbox__label' : 'noCheckbox' }`"
                                  for="isDisplayInstagramCheckbox"
                                >
                                  <div class="c-icon c-icon--instagram" :class="!store.attributes.store_social.instagram_url && 'is_disabled'">
                                    <Icon name="iconInstagram" />
                                  </div>
                                  <p>Instagram</p>
                                </label>
                              </fieldset>
                              <fieldset class="p-formGrid__item p-formGrid__item__s__12 p-formGrid__item__m__12 p-formGrid__item__l__12">
                                <input
                                  id="isDisplayLineCheckbox"
                                  v-model="isDisplayLine"
                                  type="checkbox"
                                  class="c-checkbox__input"
                                  :disabled="!store.attributes.store_social.line_url"
                                >
                                <label
                                  class="c-formLabel"
                                  :class="`${ store.attributes.store_social.line_url ? 'c-checkbox__label' : 'noCheckbox' }`"
                                  for="isDisplayLineCheckbox"
                                >
                                  <div class="c-icon c-icon--line" :class="!store.attributes.store_social.line_url && 'is_disabled'">
                                    <Icon name="iconLine" />
                                  </div>
                                  <p>Line</p>
                                </label>
                              </fieldset>
                            </div>
                          </div>
                          <div class="c-note">
                            <div class="c-note__content">
                              <i18n-t keypath="pages.CompaniesVisitorStoreEdit.snsVisibleSetting.note" tag="p">
                                <router-link
                                  :to="{ name: 'CompaniesLocationStore', params: { company_uuid: companyUuid, store_uuid: storeUuid }, query: { tab: 'sns' } }"
                                >
                                  {{ $t('labels.here') }}
                                </router-link>
                              </i18n-t>
                            </div>
                          </div>
                        </div>
                      </section>
                      <!-- お知らせ -->
                      <section class="p-box">
                        <header class="p-box__header">
                          <h3 class="p-box__title">{{ $t('pages.CompaniesVisitorStoreEdit.messageSetting.title') }}</h3>
                        </header>
                        <div class="p-box__body">
                          <Info>
                            {{ $t('pages.CompaniesVisitorStoreEdit.messageSetting.description') }}
                          </Info>
                          <div class="p-formGrid">
                            <div class="p-formGrid__items">
                              <fieldset class="p-formGrid__item p-formGrid__item__s__12 p-formGrid__item__m__12 p-formGrid__item__l__12">
                                <ul class="c-checkbox">
                                  <li class="c-checkbox__item">
                                    <input id="setupNotificationCheckbox" v-model="checkedSetupMessage" type="checkbox" class="c-checkbox__input">
                                    <label class="c-checkbox__label" for="setupNotificationCheckbox">{{ $t('labels.setupNotification') }}</label>
                                  </li>
                                </ul>
                              </fieldset>
                              <template v-if="checkedSetupMessage">
                                <fieldset class="p-formGrid__item p-formGrid__item__s__12 p-formGrid__item__m__12 p-formGrid__item__l__12">
                                  <MediaImage
                                    class="cover__form"
                                    :loading="false"
                                    :images="storeMessageImageUrlForUploader"
                                    :label-detail="$t('labels.optionalLabel')"
                                    @drop-images="onDropStoreMessageImage"
                                    @remove-image="onRemoveStoreMessageImage"
                                  />
                                  <div class="c-note messageImageInfo">
                                    <div class="c-note__content">
                                      <p>{{ $t('labels.recommendedImageSize', { width: 600, height: 500 }) }}</p>
                                    </div>
                                  </div>
                                  <Info>
                                    {{ $t('labels.mediaImageInfo') }}
                                  </Info>
                                </fieldset>
                                <fieldset class="p-formGrid__item p-formGrid__item__s__12 p-formGrid__item__m__12 p-formGrid__item__l__12">
                                  <label class="c-formLabel">{{ $t('pages.CompaniesVisitorStoreEdit.messageSetting.form.messageContent.label') }}
                                    <span>({{ $t('labels.countCharacters', {count: store.attributes.store_message.comment.length, max: 400}) }}){{ $t('labels.optionalLabel') }}</span>
                                  </label>
                                  <textarea v-model="store.attributes.store_message.comment" class="c-textArea" cols="30" rows="10" maxlength="400" :placeholder="$t('labels.placeholder.basic')" />
                                </fieldset>
                                <fieldset class="p-formGrid__item p-formGrid__item__s__12 p-formGrid__item__m__12 p-formGrid__item__l__12">
                                  <label class="c-formLabel">
                                    <p>{{ $t('pages.CompaniesVisitorStoreEdit.messageSetting.form.link.label') }}{{ $t('labels.optionalLabel') }}</p>
                                  </label>
                                  <input v-model="store.attributes.store_message.url" class="c-textField" :placeholder="$t('labels.placeholder.basic')" type="url">
                                  <div class="c-note">
                                    <div class="c-note__content">
                                      <p>{{ $t('pages.CompaniesVisitorStoreEdit.messageSetting.form.link.description') }}</p>
                                    </div>
                                  </div>
                                </fieldset>
                              </template>
                            </div>
                          </div>
                        </div>
                      </section>
                    </div>
                    <div class="c-grid__item c-grid__item__s__12 c-grid__item__m__5 c-grid__item__l__5">
                      <div class="p-preview">
                        <div class="p-preview__header">
                          {{ $t('pages.CompaniesVisitorStoreEdit.pagePreview.title') }}
                        </div>
                        <div class="p-shopImages">
                          <img alt="" class="p-shopImages__thumb" :src="storeCoverImageUrl">
                          <img alt="" class="p-shopImages__icon" :src="store.attributes.brand_image_url">
                        </div>
                        <div class="c-container">
                          <div class="p-shopHeader">
                            <h1 class="p-shopHeader__name">{{ store.attributes.name }}</h1>
                          </div>
                          <section
                            v-show="choiceType || hasVisibleSocials || hasVisibleMessage"
                            class="p-section"
                          >
                            <Choice
                              :type="choiceType"
                              :title="store.attributes.store_cover.title"
                              :comment="store.attributes.store_cover.comment"
                              :post-label="postLabel"
                              :survey-label="surveyLabel"
                            />
                          </section>
                          <section v-show="hasVisibleSocials" class="p-section">
                            <SNS
                              :facebook-url="store.attributes.store_social.facebook_url"
                              :twitter-url="store.attributes.store_social.twitter_url"
                              :instagram-url="store.attributes.store_social.instagram_url"
                              :line-url="store.attributes.store_social.line_url"
                              :is-display-facebook="isDisplayFacebook"
                              :is-display-twitter="isDisplayTwitter"
                              :is-display-instagram="isDisplayInstagram"
                              :is-display-line="isDisplayLine"
                            />
                          </section>
                          <section v-show="hasVisibleMessage" class="p-section">
                            <h2 class="c-title">{{ $t('pages.CompaniesVisitorStoreEdit.pagePreview.message') }}</h2>
                            <div class="p-info">
                              <a v-if="storeMessageImageUrl" target="_blank" :href="store.attributes.store_message.url">
                                <img alt="" class="p-info__thumb" :src="storeMessageImageUrl">
                              </a>
                              <p>{{ store.attributes.store_message.comment }}<br></p>
                              <div v-if="store.attributes.store_message.url" class="p-info__button">
                                <a target="_blank" :href="store.attributes.store_message.url">{{ $t('labels.viewDetail') }}</a>
                              </div>
                            </div>
                          </section>
                        </div>
                      </div>
                      <section class="p-box">
                        <div class="p-box__body">
                          <div class="qrcode">
                            <h3 class="qrcode__title">{{ $t('pages.CompaniesVisitorStoreEdit.qrcode.title') }}</h3>
                            <div class="qrcode__content">
                              <vue-qrcode :value="store.links.visitor" tag="img" />
                              <div class="c-button">
                                <a
                                  class="c-button__item c-button__item--outline"
                                  :href="generateQRCodeDataURL(store.links.visitor, 'svg')"
                                  :download="qrCodeFileName('svg')"
                                  @click="downloadFromMs(generateQRCodeDataURL(store.links.visitor, 'svg'), $t('pages.CompaniesVisitorStoreEdit.qrcode.downloadButton.text', { format: 'SVG' }), $event)"
                                >
                                  {{ $t('pages.CompaniesVisitorStoreEdit.qrcode.downloadButton.text', { format: 'SVG' }) }}
                                </a>
                              </div>
                              <div class="c-button">
                                <!-- TODO: id属性はデバッグ用コードだからあとで消す -->
                                <a
                                  id="download"
                                  class="c-button__item c-button__item--outline"
                                  :href="generateQRCodeDataURL(store.links.visitor, 'img')"
                                  :download="qrCodeFileName('png')"
                                  @click="downloadFromMs(generateQRCodeDataURL(store.links.visitor, 'img'), $t('pages.CompaniesVisitorStoreEdit.qrcode.downloadButton.text', { format: 'PNG' }), $event)"
                                >
                                  {{ $t('pages.CompaniesVisitorStoreEdit.qrcode.downloadButton.text', { format: 'PNG' }) }}
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </section>
                    </div>
                  </div>
                </div>
              </div>
              <div class="p-box__footer">
                <div class="c-button c-button--right">
                  <div class="c-info">
                    <div class="c-info__icon">
                      <img :src="iconCheckPath" alt="">
                    </div>
                    <div class="c-info__content">
                      <i18n-t v-if="store.attributes.visible" keypath="pages.CompaniesVisitorStoreEdit.footer.info" tag="p">
                        <a target="_blank" :href="store.links.visitor">{{ $t('labels.here') }}</a>
                      </i18n-t>
                      <p v-else>{{ $t('messages.isPrivate', { value: $t('pages.CompaniesVisitorStoreEdit.locationPage') }) }}</p>
                    </div>
                  </div>
                  <div class="c-button__item c-button__item--outline">
                    <div class="c-checkbox">
                      <div class="c-checkbox__item c-checkbox__item__s__12 c-checkbox__item__m__12 c-checkbox__item__l__12">
                        <input id="store_visible" v-model="store.attributes.visible" type="checkbox" class="c-checkbox__input">
                        <label class="c-checkbox__label" for="store_visible">{{ $t('labels.publish', { value: $t('pages.CompaniesVisitorStoreEdit.locationPage') }) }}</label>
                      </div>
                    </div>
                  </div>
                  <button class="c-button__item c-button__item--primary" @click.prevent="handleStoreSubmit">
                    {{ $t('labels.save') }}
                  </button>
                </div>
              </div>
            </form>
          </ValidationObserver>
        </template>
      </div>
    </section>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import { removeAllSpaces } from '../modules/string_converter'
import VueQrcode from '@chenfengyuan/vue-qrcode'
import QRCode from 'qrcode'
import Info from '../components/Info'
import ValidationError from '../components/ValidationError'
import Loading from '../components/Loading.vue'
import Choice from '../components/Choice.vue'
import SNS from '../components/SNS.vue'
import Icon from '../components/Icon'
import MediaImage from '../components/MediaImage'
import iconCheckPath from '../../../images/common/icon_check.svg'
import iconExclamationPath from '../../../images/common/icon_exclamation.svg'
import iconExclamationBPath from '../../../images/common/icon_exclamationB.svg'
import iconPlusPath from '../../../images/common/icon_plus.svg'
import defaultImage from '../../../images/default.png'
import formatLabelText from '../modules/formatLabelText'
import StatusBadge from '../components/StatusBadge'
import { KkIcon, KkToggleSwitch, KkSiteIcon } from '../components/base'

const EN_TITLE_DEFAULT = 'How was our service today?'
const ZH_TW_TITLE_DEFAULT = '非常感謝您的光臨！'
const KO_TITLE_DEFAULT = '본 점포의 서비스는 어떠셨습니까?'
const EN_COMMENT_DEFAULT = 'Thank you for visiting us. \nWould you consider leaving us a review?'
const ZH_TW_COMMENT_DEFAULT = '為了能持續提供給您更好的服務，煩請與我們分享您的寶貴意見。'
const KO_COMMENT_DEFAULT = '오늘은 이용해주셔서 대단히 감사합니다.\n저희 점포에 대한 의견을 남겨주십시오.'
const EN_POST_LABEL_DEFAULT = 'Post'
const ZH_TW_POST_LABEL_DEFAULT = '寫評論'
const KO_POST_LABEL_DEFAULT = '리뷰를 작성한다.'
const EN_SURVEY_LABEL_DEFAULT = 'Survey（Japanese only）'
const ZH_TW_SURVEY_LABEL_DEFAULT = '填問卷（日文）'
const KO_SURVEY_LABEL_DEFAULT = '설문조사（일본어）'

export default {
  name: 'CompaniesVisitorStoreEdit',
  components: {
    Info,
    VueQrcode,
    ValidationError,
    KkSiteIcon,
    Loading,
    Choice,
    SNS,
    Icon,
    MediaImage,
    StatusBadge,
    KkIcon,
    KkToggleSwitch
  },
  emits: ['update-title'],
  data () {
    return {
      iconCheckPath,
      iconExclamationPath,
      iconExclamationBPath,
      iconPlusPath,
      defaultImage,
      userId: gon.currentUser.id,
      title: '',
      requireStoreAddress: false,
      // メッセージの画像アップロードのファイルを保持
      storeMessageImage: null,
      images: [],
      imageError: '',
      checkedSetupMessage: false,
      checkedDeleteMessageImage: false,
      updatedStoreCoverImage: false,
      isDisplayFacebook: false,
      isDisplayInstagram: false,
      isDisplayTwitter: false,
      isDisplayLine: false,
      enableMultiLang: false
    }
  },
  computed: {
    companyUuid() { return this.$route.params.company_uuid },
    storeUuid() { return this.$route.params.store_uuid },
    ...mapState({
      company: state => state.companiesCompany.data,
      store: state => state.companiesVisitorStore.data,
      storeLoading: state => state.companiesVisitorStore.loading,
    }),
    ...mapGetters({
      hasStoreMessage: 'companiesVisitorStore/hasStoreMessage',
      providedFeaturesSurvey: 'companiesCompany/providedFeaturesSurvey',
      inboundOption: 'companiesCompany/inboundOption',
    }),
    loading() {
      return this.storeLoading
    },
    dataLoaded() {
      return this.company && this.store && !this.loading
    },
    hasStoreAddress() {
      if(!this.store) return false
      return this.store.attributes.has_address
    },
    hasVisibleSocials() {
      return this.isDisplayFacebook || this.isDisplayInstagram || this.isDisplayTwitter || this.isDisplayLine
    },
    hasVisibleMessage() {
      // urlは含まなくて良い、メッセージ設定の有無と文言か画像のどちらかがあるかで判定
      return this.checkedSetupMessage && (this.storeMessageImageUrl || this.store.attributes.store_message.comment)
    },
    storeCoverImage() {
      return this.images[0].file
    },
    storeCoverImageUrl() {
      if (this.updatedStoreCoverImage) {
        return window.URL.createObjectURL(this.storeCoverImage)
      } else {
        return this.store.attributes.cover_image_url
      }
    },
    storeMessageImageUrl() {
      // アップロード対象がある場合
      if (this.storeMessageImage) {
        return window.URL.createObjectURL(this.storeMessageImage)
      } else {
        return this.store.attributes.store_message.image_url
      }
    },
    // MediaImage componentに渡す用
    storeMessageImageUrlForUploader() {
      if (!this.storeMessageImageUrl || this.checkedDeleteMessageImage) return []

      // id, nameはMediaImage component用に仮埋め
      return [{ id: 0, url: this.storeMessageImageUrl, name: 'messageImage.png' }]
    },
    choiceType() {
      const review_visible = this.store.attributes.store_sites.some(store_site => { return store_site.visible })
      const hasPublishedSurvey = this.store.attributes.has_publishing_survey

      if(hasPublishedSurvey && review_visible) {
        if (this.store.attributes.review_site_display_location === 'survey_complete') {
          return 'survey'
        } else {
          return 'survey_or_review'
        }
      } else if(hasPublishedSurvey) {
        return 'survey'
      } else if(review_visible) {
        return 'review'
      }

      return null
    },
    postLabel() {
      return this.store.attributes.store_cover.post_label
    },
    surveyLabel() {
      return this.store.attributes.store_cover.survey_label
    },
    storeName(){
      if(!this.store) return
      return this.store.attributes.name
    },
  },
  watch: {
    title(newTitle) {
      this.$emit('update-title', newTitle)
    }
  },
  async created() {
    await this.readStore({ company_uuid: this.companyUuid, uuid: this.storeUuid })
    this.title = this.$t('pages.CompaniesVisitorStoreEdit.title', { name: this.store.attributes.name })
    this.setCoverImage()
    this.initSocial(this.store.attributes.store_social)
    // お知らせ設定のどれかに値があればチェックを入れた状態にする
    if (this.hasStoreMessage) this.checkedSetupMessage = true
    this.enableMultiLang = !!this.store.attributes.store_multi_language_cover
  },
  methods: {
    ...mapActions({
      readStore: 'companiesVisitorStore/readStore',
      updateStore: 'companiesVisitorStore/updateStore',
      updateStoreMultiForm: 'companiesVisitorStore/updateStoreMultiForm',
      updateStoreMultiFormElement: 'companiesVisitorStore/updateStoreMultiFormElement',
      readStoresRoot: 'companiesStores/readStores',
    }),
    formatLabelText,
    // MediaImage.vueに変換する時のために残しておく
    onDropMediaImage(images) {
      const _images = []
      images.forEach((image, index) => {
        _images.push({
          file: image,
          id: index,
          url: window.URL.createObjectURL(image)
        })
      })

      this.images = _images
      this.updatedStoreCoverImage = true
    },
    onRemoveMediaImage(imageId) {
      this.images = this.images.filter((image) => {
        return image.id !== imageId
      })
      this.updatedStoreCoverImage = false
    },
    onDropStoreMessageImage(images) {
      if (!images.length) return

      this.storeMessageImage = images[0]
      this.checkedDeleteMessageImage = false
    },
    onRemoveStoreMessageImage() {
      this.storeMessageImage = null
      this.store.attributes.store_message.image_url = null
      this.checkedDeleteMessageImage = true
    },
    setCoverImage() {
      this.images = [{
        url: this.store.attributes.cover_image_url,
        name: '',
        id: 0
      }]
    },
    async handleStoreSubmit() {
      const result = await this.$refs.form.validate()
      if (!result.valid) {
        alert(this.$t('messages.invalid'))
        return
      }

      const payload = {
        store: {
          visible: this.store.attributes.visible,
        },
        store_cover: this.store.attributes.store_cover,
        store_message: {
          id: this.store.attributes.store_message.id,
          comment: this.checkedSetupMessage ? this.store.attributes.store_message.comment : '',
          url: this.checkedSetupMessage ? this.store.attributes.store_message.url : '',
          remove_image: !this.checkedSetupMessage || this.checkedDeleteMessageImage,
        },
        store_social: {
          id: this.store.attributes.store_social.id,
          is_display_facebook: this.isDisplayFacebook,
          is_display_twitter: this.isDisplayTwitter,
          is_display_instagram: this.isDisplayInstagram,
          is_display_line: this.isDisplayLine,
        },
        store_sites: this.store_sites_to_object_with_index(),
        company_support_email: {
          value: this.company.attributes.support_email,
        },
      }

      if (this.updatedStoreCoverImage) {
        payload.store.cover_image =  {
          content: await this.readAsDataURL(this.storeCoverImage),
          filename: this.storeCoverImage.name,
        }
      }
      if (this.storeMessageImage) {
        payload.store_message.image =  {
          content: await this.readAsDataURL(this.storeMessageImage),
          filename: this.storeMessageImage.name,
        }
      }
      if (this.enableMultiLang) {
        payload.store_multi_language_cover = this.store.attributes.store_multi_language_cover
      }
      await this.updateStore({ company_uuid: this.companyUuid, uuid: this.storeUuid, store_form_data: payload })
      this.enableMultiLang = !!this.store?.attributes?.store_multi_language_cover
      this.resetData()

      this.readStoresRoot(this.companyUuid)
      await this.readStore({company_uuid: this.companyUuid, uuid: this.storeUuid})
      this.setCoverImage()

      window.scrollTo({top: 0})
    },
    store_sites_to_object_with_index() {
      let result = {}
      this.store.attributes.store_sites.forEach((store_site, index) => {
        result[index] = {
          id: store_site.id,
          visible: store_site.visible,
        }
      })
      return result
    },
    resetData() {
      this.storeMessageImage = null
      this.updatedStoreCoverImage = false
      this.checkedDeleteMessageImage = false
    },
    qrCodeFileName(format) {
      return this.$t(
        'pages.CompaniesVisitorStoreEdit.qrcode.downloadButton.fileName',
        { companyName: removeAllSpaces(this.company.attributes.name), storeName: removeAllSpaces(this.store.attributes.name), format: format }
      )
    },
    showError(val) {
      if(val) {
        this.$updateFlash({ type: 'alert', message: val })
      }
    },
    uploadStoreCoverImage(event) {
      this.imageError = ''
      const file = event.target.files[0]
      const MB = 1000 * 1000
      if (file.size > 5 * MB) {
        this.imageError = '画像サイズは5MB以下にしてください'
        return
      }
      this.images = [{
        file: file,
        id: 0,
        url: window.URL.createObjectURL(file)
      }]
      this.updatedStoreCoverImage = true
    },
    readAsDataURL(blob) {
      return new Promise((resolve, reject) => {
        let reader = new FileReader()
        reader.onload = () => { resolve(reader.result) }
        reader.onerror = () => { reject(reader.error) }
        reader.readAsDataURL(blob)
      })
    },
    createElementFromHTML(html) {
      const tempEl = document.createElement('div')
      tempEl.innerHTML = html
      return tempEl.firstElementChild
    },
    getDataURLFromSVG(svg) {
      const svgData = new XMLSerializer().serializeToString(this.createElementFromHTML(svg))
      return `data:image/svg+xml;base64, ${btoa(unescape(encodeURIComponent(svgData)))}`
    },
    generateQRCodeDataURL(link, format, options) {
      let dataUrl
      switch (format) {
      case 'img':
        QRCode.toDataURL(link, options, (error, url) => {
          if (error) throw error
          dataUrl = url
        })
        break
      case 'svg':
        QRCode.toString(link, options, (error, svg) => {
          if (error) throw error
          dataUrl = this.getDataURLFromSVG(svg)
        })
        break
      default:
        QRCode.toString(link, options, (error, string) => {
          if (error) throw error
          dataUrl = string
        })
      }
      return dataUrl
    },
    downloadFromMs(dataURL, fileName, e) {
      // デバッグ用に一旦残し
      // const byteString = atob(dataURL.split(',')[1])
      // const mimeType = dataURL.match(/(:)([a-z+\/]+)(;)/)[2] /* eslint-disable-line */
      // for (var i = 0, l = byteString.length, content = new Uint8Array(l); l > i; i++) {
      //   content[i] = byteString.charCodeAt(i)
      // }
      // const blob = new Blob([content], { type: mimeType })
      // console.log({byteString})
      // console.log({mimeType})
      // console.log({blob})
      // document.getElementById('download').href = window.URL.createObjectURL(blob)
      // document.getElementById('download').download = 'hoge'

      // IE 対策
      if (window.navigator.msSaveBlob) {
        e.preventDefault()
        const byteString = atob(dataURL.split(',')[1])
        const mimeType = dataURL.match(/(:)([a-z+\/]+)(;)/)[2] /* eslint-disable-line */
        for (var i = 0, l = byteString.length, content = new Uint8Array(l); l > i; i++) {
          content[i] = byteString.charCodeAt(i)
        }
        const blob = new Blob([content], { type: mimeType })
        window.navigator.msSaveBlob(blob, fileName)
      }
    },
    initSocial(social) {
      this.isDisplayFacebook = social.is_display_facebook
      this.isDisplayInstagram = social.is_display_instagram
      this.isDisplayTwitter = social.is_display_twitter
      this.isDisplayLine = social.is_display_line
    },
    clickEnableMultiToggle(value) {
      if (value) {
        if (!this.store.attributes.store_multi_language_cover) {
          this.updateStoreMultiForm({
            en_title: EN_TITLE_DEFAULT,
            zh_tw_title: ZH_TW_TITLE_DEFAULT,
            ko_title: KO_TITLE_DEFAULT,
            en_comment: EN_COMMENT_DEFAULT,
            zh_tw_comment: ZH_TW_COMMENT_DEFAULT,
            ko_comment: KO_COMMENT_DEFAULT,
            en_post_label: EN_POST_LABEL_DEFAULT,
            zh_tw_post_label: ZH_TW_POST_LABEL_DEFAULT,
            ko_post_label: KO_POST_LABEL_DEFAULT,
            en_survey_label: EN_SURVEY_LABEL_DEFAULT,
            zh_tw_survey_label: ZH_TW_SURVEY_LABEL_DEFAULT,
            ko_survey_label: KO_SURVEY_LABEL_DEFAULT,
          })
        }
      }
      this.enableMultiLang = value
    },
    restore(key) {
      switch (key) {
      case 'title':
        this.updateStoreMultiFormElement({property: 'en_title', text: EN_TITLE_DEFAULT})
        this.updateStoreMultiFormElement({property: 'zh_tw_title', text: ZH_TW_TITLE_DEFAULT})
        this.updateStoreMultiFormElement({property: 'ko_title', text: KO_TITLE_DEFAULT})
        break
      case 'comment':
        this.updateStoreMultiFormElement({property: 'en_comment', text: EN_COMMENT_DEFAULT})
        this.updateStoreMultiFormElement({property: 'zh_tw_comment', text: ZH_TW_COMMENT_DEFAULT})
        this.updateStoreMultiFormElement({property: 'ko_comment', text: KO_COMMENT_DEFAULT})
        break
      case 'postLabel':
        this.updateStoreMultiFormElement({property: 'en_post_label', text: EN_POST_LABEL_DEFAULT})
        this.updateStoreMultiFormElement({property: 'zh_tw_post_label', text: ZH_TW_POST_LABEL_DEFAULT})
        this.updateStoreMultiFormElement({property: 'ko_post_label', text: KO_POST_LABEL_DEFAULT})
        break
      case 'surveyLabel':
        this.updateStoreMultiFormElement({property: 'en_survey_label', text: EN_SURVEY_LABEL_DEFAULT})
        this.updateStoreMultiFormElement({property: 'zh_tw_survey_label', text: ZH_TW_SURVEY_LABEL_DEFAULT})
        this.updateStoreMultiFormElement({property: 'ko_survey_label', text: KO_SURVEY_LABEL_DEFAULT})
        break
      }
    }
  },
}
</script>


<style lang="scss" scoped>
.pageHeader {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex-wrap: nowrap;

  @media screen and (max-width: 768px) {
    flex-direction: column-reverse;

    .c-button {
      margin: 0 0 16px auto !important;
    }
  }

  .c-button {
    margin: 0;

    &__item {
      margin: 0;
    }
  }
}
.p-preview {
  border: 3px solid #3A3B3F;
  border-radius: 4px;

  &__header {
    background-color: #3A3B3F;
    color: #fff;
    font-weight: bold;
    font-size: 12px;
    padding: 12px;
  }

  .c-container {
    $root: #{&};
    padding-right: 16px;
    padding-left: 16px;
    padding-bottom: 16px;
  }

  .c-title {
    $root: #{&};
    margin-bottom: 8px;
    font-weight: bold;
    font-size: 14px;
    line-height: 1.71;
  }

  .p-shopImages {
    $root: #{&};
    position: relative;
    margin-bottom: 112px;
    &__thumb {
      display: block;
      width: 100%;
      max-height: 512px;
      object-fit: cover;
    }
    &__icon {
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translate(-50%, 50%);
      width: 47%;
      max-width: 176px;
      border-radius: 10px;
      box-shadow: 0 4px 8px rgba(0, 0, 0, .06);
      overflow: hidden;
      background: #FFF;
    }
  }

  .p-shopHeader {
    $root: #{&};
    margin-bottom: 24px;
    text-align: center;
    &__name {
      margin-bottom: 40px;
      font-weight: bold;
      font-size: 18px;
      line-height: 1.33;
      letter-spacing: 1px;
      &:last-child {
        margin-bottom: 0;
      }
    }
    &__lead {
      font-weight: bold;
      font-size: 16px;
      line-height: 1.5;
    }
    &__text {
      margin-top: 8px;
      font-size: 14px;
      line-height: 1.71;
    }
  }

  .p-section {
    $root: #{&};
    &:not(:first-child) {
      margin-top: 40px;
    }
    &:not(:last-child) {
      margin-bottom: 40px;
    }
  }

  .p-info {
    $root: #{&};
    padding: 24px;
    border-radius: 10px;
    background-color: #F4F4F4;
    overflow-wrap: break-word;
    p {
      margin-top: 16px;
      font-size: 14px;
      line-height: 1.71;
      white-space: pre-wrap;
    }
    &__thumb {
      display: block;
      max-width: 100%;
      margin: 0 auto;
      border-radius: 8px;
    }
    &__button {
      margin-top: 16px;
      text-align: right;
      a {
        display: inline-flex;
        justify-content: center;
        align-items: center;
        height: 34px;
        padding: 0 24px;
        border-radius: 17px;
        background-color: #ECECEC;
        font-weight: bold;
        font-size: 12px;
        line-height: 1.5;
        text-decoration: none;
      }
    }
  }
}
.p-formGrid {
  &:not(:first-child) {
    margin-top: 0;
  }
}
.qrcode {
  &__name {
    font-weight: bold;
    font-size: 14px;
  }
  &__content {
    max-width: 204px;
    margin-right: auto;
    margin-left: auto;
    img {
      width: 100%;
    }
  }
  .c-button {
    margin: 0;
    &__item {
      margin: 0;
      font-size: 12px;
    }
    + .c-button {
      margin-top: 16px;
    }
  }
}
.c-radio {
  margin-top: 20px;
  &__item {
    flex-basis: 100%;
  }
  &__label {
    display: block;
  }
}

.messageImageInfo {
  margin-top: 0px;
  margin-bottom: 8px;
}

.noCheckbox {
  margin-left: 24px;
}

.visibleSite {
  ul {
    width: 100%;
  }
}

.multiLang {
  background-color: #F4F4F4;
  padding: 16px;
  margin-top: 16px;
  border-radius: 4px;
  &__status {
    font-size: 12px;
  }
  .c-formLabel{
    margin-top: 24px;
  }
  &__restore {
    margin-top: 16px;
    display: flex;
    color: #3A3B3F;
    opacity: 0.5;
    font-size: 12px;
    &__icon {
      width: 12px;
      position: relative;
      top: 6px;
      margin-right: 8px;
    }
  }
}
</style>
